module.exports = __webpack_public_path__ + "img/can.c976442e.svg";